import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
// import { DocumentsComponent } from './documents/components/documents/documents.component';
// import { UploaderComponent } from './documents/components/uploader/uploader.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormGuideModule } from './form-guide/form-guide.module';
import { AlertsModule } from '../shared/alerts/modules/alerts.module';
import { BreadcrumbComponent } from '../shared/breadcrumb/breadcrumb.component';
import { BreadcrumbrouteComponent } from '../shared/breadcrumb/breadcrumbroute/breadcrumbroute.component';
import { AlertMessageModule } from './alert-message/alert-message.module';
import { FilterByPipe } from './form-guide/pipes/filter-by.pipe';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ListingCardsComponent } from './listing-cards/listing-cards.component';
import { ApplicantCommentComponent } from './request/applicant-comment/applicant-comment.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RequestHeaderComponent } from './request/request-header/request-header.component';
import { PopupNotificationComponent } from './request/popup-notification/popup-notification.component';
import { CanDeactivateGuard } from './Models/_gards/can-deactivate.guard';
import { DocumentUploaderComponent } from './request/document-uploader/document-uploader.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PopupConfirmationComponent } from './request/popup-confirmation/popup-confirmation.component';
import { LoaderService } from './services/loader.service';
import { UploadService } from './request/document-uploader/_services/upload.service';
import { StripHtmlPipe, HtmlSpacesPipe } from './form-guide/pipes/striphtml.pipe';
import { UserConfigService } from './services/userConfig.service';
import { HeaderInterceptorService } from './services/HeaderInterceptor.service';
import { AnnoncementModelComponent } from './annoncement-model/annoncement-model.component';
import { FormatDatePipe } from './custom-pipes/format-date.pipe';
import { TrimLinePipe } from './custom-pipes/trim-line.pipe';
import { ArabicNumberPipe } from './custom-pipes/arabic-number.pipe';
import { BahrainiDinarPipe } from './custom-pipes/bahraini-dinar.pipe';

import { NotfoundpageComponent } from '../notfoundpage/notfoundpage.component';
import { GeneralDocumentUploaderComponent } from './request/document-uploader/general-document-uploader/general-document-uploader.component';
import { RedirectionComponent } from './redirection-component/redirection.component';
import { QuarterFilterComponent } from './Quarter-Filter/Quarter-Filter.component';
import { ParallelSendbackGridEdit } from './parallel-sendback-grid-edit/parallel-sendback-grid-edit';
import { CommentComponent } from './ALd Components/components/comment/comment.component';
import { AldApplicantCommentComponent } from './request/ald-applicant-comment/ald-applicant-comment.component';
import { ActionItemGridComponent } from '../action-items/action-item-grid/action-item-grid.component';
import { DocumentsDisclaimerComponent } from './ALd Components/components/documents-disclaimer/documents-disclaimer.component';
import { ALDRequestHeaderComponent } from './request/ald-request-header/ald-request-header.component';
import { AircraftProfileFields } from './ALd Components/components/aircraft-profile-fields/aircraft-profile-fields.component';
import { AldMtoRequestHeaderComponent } from './request/ald-mto-request-header/ald-mto-request-header.component';
import { AircraftOwnersDetailsComponent } from '../ald-aircraft-registration-service-request/components/aircraft-owners-details/aircraft-owners-details.component';
import {RelatedAmosComponent} from "../ald-account/components/related-amos/related-amos.component";
import {YesNoToggleComponent} from "./ALd Components/components/yes-no-toggle/yes-no-toggle";
import { ClassTypePipe } from './custom-pipes/classType.pipe';
import {SectionTitle} from "./ALd Components/components/section-title/section-title";
import {
  OfficesDetailsComponent
} from "../ald-grant-aoc-service-request/components/offices-details/offices-details.component";
import {
  PostHoldersDetailsComponent
} from "../ald-grant-aoc-service-request/components/post-holders-details/post-holders-details.component";
import {
  BasicAcrInformationDetailsComponent
} from "../ald-grant-aoc-service-request/components/basic-acr-information-details/basic-acr-information-details.component";

const guards = [];

const services = [
  // ServiceCatalogueService
];

const pipes = [
  FilterByPipe,
  TrimLinePipe,
  StripHtmlPipe,
  FormatDatePipe,
  HtmlSpacesPipe,
  TrimLinePipe,
  ArabicNumberPipe,
  BahrainiDinarPipe,
  ClassTypePipe
];

const modules = [
  HttpClientModule,
  RouterModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  FormGuideModule,
  AlertsModule,
  AlertMessageModule,
  ModalModule,
  // ActionItemsModule,
  //AttachemntUploaderModule,
  // BrowserAnimationsModule,
];

const components = [
  BasicAcrInformationDetailsComponent,
  PostHoldersDetailsComponent,
  OfficesDetailsComponent,
  SectionTitle,
  YesNoToggleComponent,
  RelatedAmosComponent,
  AircraftProfileFields,
  DocumentsDisclaimerComponent,
  ActionItemGridComponent,
  BreadcrumbComponent,
  BreadcrumbrouteComponent,
  ListingCardsComponent,
  ApplicantCommentComponent,
  AldApplicantCommentComponent,
  RequestHeaderComponent,
  ALDRequestHeaderComponent,
  PopupNotificationComponent,
  DocumentUploaderComponent,
  PopupConfirmationComponent,
  QuarterFilterComponent,
  ParallelSendbackGridEdit,
  AircraftOwnersDetailsComponent,
  // DocumentsComponent,
  // UploaderComponent
  DocumentUploaderComponent,
  GeneralDocumentUploaderComponent,
  AnnoncementModelComponent,
  RedirectionComponent,
  ParallelSendbackGridEdit,
  CommentComponent,
  AldMtoRequestHeaderComponent
];

@NgModule({
  imports: [...modules, NgbModule.forRoot(), CollapseModule.forRoot(), TranslateModule],
  declarations: [...components, ...pipes, FormatDatePipe, TrimLinePipe, ArabicNumberPipe, BahrainiDinarPipe,ClassTypePipe],
  providers: [
    CanDeactivateGuard,
    LoaderService,
    UploadService,
    UserConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptorService,
      multi: true, // Add this line when using multiple interceptors.
    },
  ],
  exports: [...modules, ...components, ...pipes, NgbModule, CollapseModule],
  entryComponents: [PopupNotificationComponent, PopupConfirmationComponent],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [...pipes, ...guards, ...services],
    };
  }
}
